import { render, staticRenderFns } from "./ResendMailDialog.vue?vue&type=template&id=b1769ce6&scoped=true&lang=pug&"
import script from "./ResendMailDialog.vue?vue&type=script&lang=js&"
export * from "./ResendMailDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResendMailDialog.vue?vue&type=style&index=0&id=b1769ce6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1769ce6",
  null
  
)

export default component.exports